import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";

const initialState = {
  activeStep: 1,
  dataValidationErrorModal: false,
  uploadFile: {
    name: "",
    folderName: "",
  },
  dataValidationUploadProcessData: {
    loading: false,
    data: {},
    error: null,
  },
  dataValidationFileValidationData: {
    loading: false,
    data: {},
    error: null,
  },
  dataValidationFileConversionData: {
    loading: false,
    data: {},
    error: null,
  },
  dataValidationFileDownloadValidationData: {
    loading: false,
    data: {},
    error: null,
  },
  dataValidationFileTraking: {
    loading: false,
    data: {},
    error: null,
  },
  dataConversionFileTracking: {
    loading: false,
    data: {},
    error: null,
  },
};

export const dataValidationUploadProcess = createAsyncThunk(
  "/dataValidationUploadProcess",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${"/upload_csv_Files_data_validation"}?folder_name=${payload?.folder_name}&file_name=${payload?.file_name}`)
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while uploading file:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "file cannot uploaded",
      );
    }
  },
);

export const dataValidationFileValidation = createAsyncThunk(
  "/dataValidationFileValidation",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/csv_glue_job_validation_data_validation", payload
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while validation file:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "file validation error",
      );
    }
  },
);

export const dataValidationFileConversion = createAsyncThunk(
  "/dataValidationFileConversion",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/csv_glue_job_conversion_data_validation",
        payload,
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while processing file:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "file processing error",
      );
    }
  },
);

export const dataValidationFileDownloadValidation = createAsyncThunk(
  "/dataValidationFileDownloadValidation",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.get(
        "/download_hcp_file_data_validation",
        {
          params: {
            folder_name: payload?.folder_name,
            file_name: payload?.file_name,
          },
        },
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while downloading file:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "file download error",
      );
    }
  },
);


export const validationFileTraking = createAsyncThunk(
  "/validationFileTraking",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.get(
        "/tracking_validation_glue_data_validation",
        {
          params: {
            job_run_id: payload?.job_run_id,
            folder_name: payload?.folder_name,
          },
        },
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while validation file:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "file validation error",
      );
    }
  },
);


export const conversionFileTracking = createAsyncThunk(
  "/conversionFileTracking",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
    
      const response = await axiosInstance.get(
  "/tracking_conversion_glue_validation_data_validation",
 
        {
          params: {
            job_run_id: payload?.job_run_id,
            folder_name: payload?.folder_name,
          },
        },
      );
      return fulfillWithValue(response);
    } catch (error) {
      console.error("Error while validation file:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "file validation error",
      );
    }
  },
);

const dataValidationSlicer = createSlice({
  name: "dataValidation",
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setDataValidationErrorModal: (state, action) => {
      state.dataValidationErrorModal = action.payload;
    },
    setUploadFile: (state, action) => {
      state.uploadFile = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(dataValidationUploadProcess.pending, (state) => {
        state.dataValidationUploadProcessData.loading = true;
        state.dataValidationUploadProcessData.error = null;
      })
      .addCase(dataValidationUploadProcess.fulfilled, (state, action) => {
        state.dataValidationUploadProcessData.loading = false;
        state.dataValidationUploadProcessData.data = action.payload;
      })
      .addCase(dataValidationUploadProcess.rejected, (state, action) => {
        state.dataValidationUploadProcessData.loading = false;
        state.dataValidationUploadProcessData.error = action.payload;
      })
      .addCase(dataValidationFileValidation.pending, (state) => {
        state.dataValidationFileValidationData.loading = true;
        state.dataValidationFileValidationData.error = null;
      })
      .addCase(dataValidationFileValidation.fulfilled, (state, action) => {
        state.dataValidationFileValidationData.loading = false;
        state.dataValidationFileValidationData.data = action.payload;
      })
      .addCase(dataValidationFileValidation.rejected, (state, action) => {
        state.dataValidationFileValidationData.loading = false;
        state.dataValidationFileValidationData.error = action.payload;
      })
      .addCase(dataValidationFileConversion.pending, (state) => {
        state.dataValidationFileConversionData.loading = true;
        state.dataValidationFileConversionData.error = null;
      })
      .addCase(dataValidationFileConversion.fulfilled, (state, action) => {
        state.dataValidationFileConversionData.loading = false;
        state.dataValidationFileConversionData.data = action.payload;
      })
      .addCase(dataValidationFileConversion.rejected, (state, action) => {
        state.dataValidationFileConversionData.loading = false;
        state.dataValidationFileConversionData.error = action.payload;
      })
      .addCase(dataValidationFileDownloadValidation.pending, (state) => {
        state.dataValidationFileDownloadValidationData.loading = true;
        state.dataValidationFileDownloadValidationData.error = null;
      })
      .addCase(
        dataValidationFileDownloadValidation.fulfilled,
        (state, action) => {
          state.dataValidationFileDownloadValidationData.loading = false;
          state.dataValidationFileDownloadValidationData.data = action.payload;
        },
      )
      .addCase(
        dataValidationFileDownloadValidation.rejected,
        (state, action) => {
          state.dataValidationFileDownloadValidationData.loading = false;
          state.dataValidationFileDownloadValidationData.error = action.payload;
        },
      )
      .addCase(validationFileTraking.pending, (state) => {
        state.dataValidationFileTraking.loading = true;
        state.dataValidationFileTraking.error = null;
      })
      .addCase(
        validationFileTraking.fulfilled,
        (state, action) => {
          state.dataValidationFileTraking.loading = false;
          state.dataValidationFileTraking.data = action.payload;
        },
      )
      .addCase(
        validationFileTraking.rejected,
        (state, action) => {
          state.dataValidationFileTraking.loading = false;
          state.dataValidationFileTraking.error = action.payload;
        },
      )
      .addCase(conversionFileTracking.pending, (state) => {
        state.dataConversionFileTracking.loading = true;
        state.dataConversionFileTracking.error = null;
      })
      .addCase(
        conversionFileTracking.fulfilled,
        (state, action) => {
          state.dataConversionFileTracking.loading = false;
          state.dataConversionFileTracking.data = action.payload;
        },
      )
      .addCase(
        conversionFileTracking.rejected,
        (state, action) => {
          state.dataConversionFileTracking.loading = false;
          state.dataConversionFileTracking.error = action.payload;
        },
      )

});

export const { setActiveStep, setDataValidationErrorModal, setUploadFile } =
  dataValidationSlicer.actions;

export default dataValidationSlicer.reducer;
